import { createSlice } from "@reduxjs/toolkit";
import {
  getArbitrationProceedingsByCaseIDAction,
  createArbitrationProceedingAction,
  updateArbitrationProceedingAction,
  deleteArbitrationProceedingAction,
  getArbitrationProceedingAction,
} from "../../actions/ArbitrationProceedings/arbitrationProceedingsAction";

const initialState = {
  proceedings: [],
  selectedProceeding: null,
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

const arbitrationProceedingsSlice = createSlice({
  name: "arbitrationProceedings",
  initialState,
  reducers: {
    clearProceedingsError: (state) => {
      state.error = null;
    },
    clearProceedingsSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
    resetSelectedProceeding: (state) => {
      state.selectedProceeding = null;
    },
  },
  extraReducers: (builder) => {
    // GET ALL BY CASE ID
    builder
      .addCase(getArbitrationProceedingsByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getArbitrationProceedingsByCaseIDAction.fulfilled, (state, action) => {
        state.loading = false;
        state.proceedings = action.payload.data || [];
      })
      .addCase(getArbitrationProceedingsByCaseIDAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load proceedings";
      });

    // CREATE
    builder
      .addCase(createArbitrationProceedingAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createArbitrationProceedingAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Arbitration proceeding created successfully";
        state.proceedings.push(action.payload.data);
      })
      .addCase(createArbitrationProceedingAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create proceeding";
      });

    // UPDATE
    builder
      .addCase(updateArbitrationProceedingAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateArbitrationProceedingAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Arbitration proceeding updated successfully";
        const index = state.proceedings.findIndex(
          (p) => p.id === action.payload.data.id
        );
        if (index !== -1) {
          state.proceedings[index] = action.payload.data;
        }
      })
      .addCase(updateArbitrationProceedingAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to update proceeding";
      });

    // DELETE
    builder
      .addCase(deleteArbitrationProceedingAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteArbitrationProceedingAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Arbitration proceeding deleted successfully";
        state.proceedings = state.proceedings.filter(
          (p) => p.id !== action.payload
        );
      })
      .addCase(deleteArbitrationProceedingAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to delete proceeding";
      });

    // GET SINGLE
    builder
      .addCase(getArbitrationProceedingAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getArbitrationProceedingAction.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedProceeding = action.payload.data;
      })
      .addCase(getArbitrationProceedingAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load proceeding details";
      });
  },
});

export const {
  clearProceedingsError,
  clearProceedingsSuccess,
  resetSelectedProceeding,
} = arbitrationProceedingsSlice.actions;

export default arbitrationProceedingsSlice.reducer;
